import React, { useState } from 'react';
import { LegalModal, LegalType } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<LegalType | null>(null);
  return <>
      <footer className="py-12 px-4 bg-[#0a0a0a] border-t border-[#1a1a1a] text-center" data-id="element-41">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-42">
          <p className="text-[#C9A84C] font-serif font-bold tracking-widest text-sm uppercase" data-id="element-43">
            El Azúcar Silencioso
          </p>

          <p className="text-sm text-[#555] max-w-2xl mx-auto" data-id="element-44">
            Solo con fines educativos. Este producto no brinda consejo médico,
            diagnóstico ni tratamiento.
          </p>
          <p className="text-sm text-[#555]" data-id="element-45">
            Producto digital. Todas las ventas son finales. Revisa tu correo
            después de la compra para el enlace de descarga.
          </p>

          <div className="flex items-center justify-center gap-6 pt-2" data-id="element-46">
            <button onClick={() => setOpenModal('privacy')} className="text-sm text-[#888] hover:text-[#C9A84C] transition-colors duration-200 underline underline-offset-4 decoration-[#444] hover:decoration-[#C9A84C]" data-id="element-47">
              Política de Privacidad
            </button>
            <span className="text-[#444]" data-id="element-48">|</span>
            <button onClick={() => setOpenModal('terms')} className="text-sm text-[#888] hover:text-[#C9A84C] transition-colors duration-200 underline underline-offset-4 decoration-[#444] hover:decoration-[#C9A84C]" data-id="element-49">
              Términos de Uso
            </button>
          </div>

          <div className="pt-4 text-xs text-[#444]" data-id="element-50">
            © 2025 El Azúcar Silencioso. Todos los derechos reservados.
          </div>
        </div>
      </footer>

      {openModal && <LegalModal type={openModal} onClose={() => setOpenModal(null)} data-id="element-51" />}
    </>;
}